import { render, staticRenderFns } from "./job-list.vue?vue&type=template&id=0827a80b&scoped=true&"
import script from "./job-list.vue?vue&type=script&lang=js&"
export * from "./job-list.vue?vue&type=script&lang=js&"
import style0 from "./job-list.vue?vue&type=style&index=0&id=0827a80b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0827a80b",
  null
  
)

export default component.exports